<template>
    <div class="flex flex-col items-center">
        <transition mode="out-in">
            <div
                v-if="!hasInterruption"
                class="w-full"
                :class="{'flex flex-col items-center gap-y-10 large:gap-y-7': activeQuestion.answersMulti}"
            >
                <QuestionInputs
                    :type="activeQuestion.answersMulti ? 'multiple' : 'single'"
                    :title="activeQuestion.title"
                    :text="activeQuestion.description"
                    :part-text="questionDepth > 1 ? `${$root.config.translations.misc.part} ${questionDepth}` : ''"
                    :values="activeQuestion.answers"
                    :flex-config="{
                        desktop: {
                            cols: activeQuestion.answersColumns,
                            gap: activeQuestion.answersColumns === 1 ? null : '1.25rem',
                            maxWidth: activeQuestion.answersColumns === 1 ? '32.625rem' : '54.375rem',
                            tall: activeQuestion.answersColumns === 1 ? false : true
                        }
                    }"
                    @value-changed="value => onValueChanged(activeQuestion.answersMulti, value)"
                />
                <div
                    v-if="activeQuestion.answersMulti"
                    class="w-full flex justify-center"
                >
                    <button
                        class="button button--primary-on-light"
                        @click="onMultiNext"
                        :disabled="!currentSelection?.length"
                    >
                        {{ $root.config.translations.misc.nextStep }}
                    </button>
                </div>
            </div>
            <Interruption
                v-else-if="interruptionContent && hasInterruption"
                :config="{content: interruptionContent}"
                @goToNext="goToNext"
            />
        </transition>
    </div>
</template>

<script>
    import QuestionInputs from '@/apps/quiz/components/QuestionInputs.vue';
    import Interruption from '@/apps/quiz/components/Interruption.vue';

    export default {
        components: {
            QuestionInputs,
            Interruption
        },
        props: {
            question: {
                type: Object,
                required: true
            },
            index: {
                type: Number,
                required: true
            }
        },
        data() {
            return {
                activeQuestion: this.question,
                questionDepth: 1,
                currentSelection: [],
                selectedValues: [],
                interruptionContent: null,
                hasInterruption: false
            };
        },
        methods: {
            onValueChanged (isMulti, value) {
                if (isMulti) {
                    this.currentSelection = value;
                    return;
                }

                this.advanceQuestion([value]);
            },
            onMultiNext () {
                this.advanceQuestion(this.currentSelection);
            },
            advanceQuestion (selectedValue) {
                const selectedIds = Array.isArray(selectedValue) ? selectedValue : [selectedValue];
                if (!selectedIds.length) return;

                this.selectedValues = this.selectedValues.concat(selectedIds);

                const interruption = this.getInterruption(this.activeQuestion, selectedIds);
                if (interruption) {
                    this.interruptionContent = interruption;
                    setTimeout(() => {
                        this.hasInterruption = true;
                        this.scrollToTop();
                    }, 300);
                    return;
                }

                const nextConditionalQuestion = this.getNextConditionalQuestion(this.activeQuestion, selectedIds);

                if (nextConditionalQuestion) {
                    this.activeQuestion = nextConditionalQuestion;
                    this.questionDepth += 1;
                    this.currentSelection = [];
                    this.$root.config.navigation.secondary = true;

                    setTimeout(() => {
                        this.scrollToTop();
                    }, 300);
                    return;
                }

                this.goToNext();
            },
            getNextConditionalQuestion(question, selectedIds) {
                const answers = (question && question.answers) || [];
                const selectedAnswers = answers.filter(answer => answer && selectedIds.includes(answer.id));
                const conditionalAnswer = selectedAnswers.find(answer => answer.conditional_question);

                return conditionalAnswer ? conditionalAnswer.conditional_question : null;
            },
            getInterruption(question, selectedIds) {
                const answers = (question && question.answers) || [];
                const match = answers.find(answer => answer && selectedIds.includes(answer.id));

                return match && match.interruption && Object.keys(match.interruption).length > 0
                    ? match.interruption
                    : null;
            },
            scrollToTop () {
                if (window.innerWidth < 1024) {
                    window.scrollTo(0, 0);
                    return;
                }

                document.querySelector('.js-route-content-container')?.scrollTo(0, 0);
            },
            goToNext () {
                const routes = this.$router.options.routes;
                const nextRoute = routes[this.index + 1].name || 'EmailOptIn';
                const params = {
                    ...this.$route.params,
                    [this.$route.meta.writeKey]: this.selectedValues.join(',')
                };

                this.$router.push({
                    name: nextRoute,
                    params
                });
            }
        }
    };
</script>

<style scoped>
    .v-enter-active,
    .v-leave-active {
        transition: all 0.3s ease-out;
    }

    .v-enter-from,
    .v-leave-to {
        @apply opacity-0;
    }
</style>
